export const UsEntityAgreementNames = {
  MASTER_CLIENT_AGREEMENT_US: 'MASTER_CLIENT_AGREEMENT_US',
  END_CUSTOMER_TERMS: 'END_CUSTOMER_TERMS',
}
